import SubscriptionForm from "./SubscriptionForm";
import { isLoggedIn, logout } from "./api";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {

  const navigate = useNavigate();
  const loggedIn = isLoggedIn();
  
  return (
    <footer className="footer-container">
      <div className="max-width horizontal gap-20 mb-vertical">
        <div className="vertical gap-10 full-width">
          <h2>REN</h2>
          <div>
            We believe in people over politics. Join us as we work together to inspire our youth, support our communities, and build a future where every voice is heard. 
          </div>
          <div className="horizontal gap-10">
            <a href="https://www.facebook.com/share/1FCQr2sGa3/?mibextid=wwXIfr">

              <i className="footer-Social-links bi-facebook"></i>
            </a>
            {/* <i className="footer-Social-links bi-twitter"></i> */}
            <a href="https://www.linkedin.com/in/ren-nushaj-a9bb549?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">
            <i className="footer-Social-links bi-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/ren_nushaj_for_mi_senate?igsh=MWVrcjV4eDF5bzR0bA==">
            <i className="footer-Social-links bi-instagram"></i>
            </a>
            {/* <i className="footer-Social-links bi-pinterest"></i> */}
          </div>
        </div>
        <div className="vertical gap-10 full-width">
          <h2>Site Map</h2>
          <ul>
            <li><Link to="/home">Home</Link></li>

            <li><Link to="/about">About US</Link></li>
            <li><Link to="/ren on issue">Ren On Issues</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/news">News & Blogs</Link></li>
          </ul>
        </div>

        <div className="vertical gap-10 full-width">
          <h2>Quick Links</h2>
          <ul>
            <li><Link to="/ContactUs">Contact Us</Link></li>
            <li><Link to="/sms-opt-in">Get Text Updates</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            {!loggedIn && <li> <Link to="/login" className="">Login</Link></li>}
            {loggedIn && (
              <>
              <li>
                <button className="" style={{ background: 'none', border: 'none' }} onClick={() => navigate('/dashboard')}>Dashboard</button>
              </li>
              <li>
                <button className="" style={{ background: 'none', border: 'none' }} onClick={() => { logout(navigate); }}>Logout</button>
              </li>
              </>
            )}
          </ul>
        </div>
        <div className="vertical gap-10 full-width">
          <h2>Subscribe</h2>
          <SubscriptionForm />
        </div>

      </div>

      <div className="max-width">
        <div className="horizontal justify-center full-width">
          <div style={{paddingTop: " 40px", textAlign: "center"}}>Paid for by Ren Nushaj for MI State Senate <br />5960 Livernois Troy, MI 48098</div>
        </div>

      </div>

      <div className="section-margin-half"></div>


      <hr />
      <div className="max-width">
        <div className="horizontal justify-center full-width">
          <div style={{paddingTop: " 40px"}}>© 2025 Renis. All rights reserved. Developed by <a href="https://hawksai.net/">Hawksai Inc.</a> </div>
        </div>

      </div>
    </footer>


  );
}

export default Footer;